import { serverSidePagePrepare } from "@lib/hooks"
import { observer } from "mobx-react"
import {
  DocumentTemplate,
  Header,
  Page,
  PureLogo,
  useStore,
} from "@features/common"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import { PrivacyLogo } from "@features/privacy"
import {
  DesktopTableOfContents,
  LegalSectionView,
  PreviousVersions,
  TouchTableOfContents,
} from "@features/terms"
import { dateFormater } from "@lib/date"
import { redirect } from "@lib/isomorphic"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models, ctx }) => {
    const { effective_date } = ctx.query
    const queryDate = Array.isArray(effective_date)
      ? effective_date[0]
      : effective_date

    try {
      await Models.LegalModel.getCaliforniaPrivacyPageData(queryDate)
    } catch {
      redirect(`/${Models.GlobalModel.lang}/not-found`, ctx)
    }
  },
})

const PrivacyCaliforniaPage = observer(function CaliforniaPrivacyPage() {
  const {
    GlobalModel: { openMenu },
    LegalModel: {
      californiaPrivacySections,
      californiaPrivacyTitle,
      californiaPrivacyEffectiveDate,
      californiaPrivacyVersions,
    },
  } = useStore()

  return (
    <Page
      meta={{
        title: "Notice at Collection",
      }}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/legal/notice-at-collection"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                <PrivacyLogo />
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      seoH1={californiaPrivacyTitle}
    >
      <div className="container pt-3 pb-15 laptop:pt-8 laptop:pb-20 legal-document">
        {californiaPrivacySections.length > 1 ? (
          <TouchTableOfContents tableOfContents={californiaPrivacySections} />
        ) : null}
        <DocumentTemplate
          sidebar={
            californiaPrivacySections.length > 1 ? (
              <DesktopTableOfContents
                tableOfContents={californiaPrivacySections}
              />
            ) : null
          }
        >
          <section className="space-y-10" id="scrollContainerElement">
            {californiaPrivacySections.map((i) => (
              <LegalSectionView data={i} key={i.id} id={i.id} />
            ))}
            <div>
              <div className="pb-3">
                <strong>Effective date:</strong>{" "}
                {californiaPrivacyEffectiveDate
                  ? dateFormater(
                      new Date(californiaPrivacyEffectiveDate),
                      "dd MMMM yyyy",
                      "en",
                    )
                  : ""}
              </div>
              <PreviousVersions versions={californiaPrivacyVersions} />
            </div>
          </section>
        </DocumentTemplate>
      </div>
    </Page>
  )
})

export default PrivacyCaliforniaPage
